// DevExtreme license key holder (do NOT commit real keys)

import { environment } from "@env/environment";

// Set the DevExtreme license key in environment.delk (env files or CI).
export const licenseKey = environment.delk; 
